<div fxLayout="column" [formGroup]="form">
	<div fxLayout fxLayoutGap="10px" fxLayoutAlign="space-between">
		<mat-form-field fxFlex>
			<mat-label>File Name</mat-label>
			<input
				maxlength="100"
				readonly
				matInput
				formControlName="fileName"
				placeholder="File Name"
			/>
			<mat-error>File name must be under 100 characters</mat-error>
		</mat-form-field>
		<button
			fxFlexAlign="center"
			mat-raised-button
			color="primary"
			(click)="fileInput.click()"
		>
			Browse
			<input
				hidden
				type="file"
				#fileInput
				(change)="uploadFile($event)"
			/>
		</button>
	</div>

	<mat-form-field>
		<input
			matInput
			formControlName="title"
			placeholder="Title"
			maxlength="100"
		/>
		<mat-error>Required </mat-error>
	</mat-form-field>
	<mat-checkbox formControlName="hideFromCustomer"
		>Hide from customers</mat-checkbox
	>
	<mat-checkbox formControlName="hideFromFieldWorker"
		>Hide from field workers</mat-checkbox
	>
	<div
		matTooltip="Documents hidden from customers cannot be included in invoicing."
		[matTooltipDisabled]="!hiddenFromCustomers"
	>
		<mat-checkbox formControlName="includeInInvoicing"
			>Include in invoicing</mat-checkbox
		>
	</div>
</div>
